import React from 'react';

const GAEventContext = React.createContext(() => {
});

export default GAEventContext;